import { useMemo } from 'react';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import { useAppSelector } from '@reduxStore';
import { CompanySettingsMap } from '@/Infrastructure/Configuration/CompanySettingsMap';
import { AppSettings } from '@/Infrastructure/Configuration/types';
import PowerBIReport from './PowerBiContainer';
import { buildPBiSplashEmbedConfig } from './EmbedConfigs';

import styles from './powerbi.module.css';

/**
 * Landing page for terminals with usePowerBISplash, shown in place of the Board.
 */
export default function SplashReport() {
  const { number: terminalNumber } = useCurrentTerminal();
  const company = useAppSelector((state) => (state.appSettings as AppSettings).company);
  const reportSettings = CompanySettingsMap[company].powerBiSplash;
  const embedConfig = useMemo(
    () => (reportSettings ? buildPBiSplashEmbedConfig(reportSettings, terminalNumber) : null),
    [reportSettings, terminalNumber]
  );

  if (!embedConfig) return null;

  return (
    <div className={styles.splash}>
      <PowerBIReport embedConfig={embedConfig} />
    </div>
  );
}
